import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APIUrls } from '../http/common/web-configuration.service';

@Injectable()
export class Http401Interceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && request.url != APIUrls.getLoginUrl()) {
          // Redirect to login page
          // Go to home page
          console.log('401 for ' + request.url);
          this.router.navigate(['/login']);
          return throwError('Logged out');
        } else if (
          error.status === 401 &&
          request.url == APIUrls.getLoginUrl()
        ) {
          return throwError(error.message);
        } else if (error.status === 404) {
          console.log('404 for ' + request.url);
          return throwError(undefined);
        } else {
          return throwError(error);
        }
      })
    );
  }
}
